import { useParams } from "react-router";
import { DashboardUtils } from "../../../dashboard_utils";
import { useGuildMemberQuery } from "../hooks/use_guild_members";
import { WithTooltip } from "../tooltips/with_tooltip";

export default function MemberDisplayNameWithTooltip(props: {
	user_id: string;
	include_discriminator?: boolean;
	include_avatar?: boolean;
	tooltip_type?: "Title" | "SeshTooltip" | "None";
}) {
	const { server_id } = useParams<{ server_id: string }>();
	const members_query = useGuildMemberQuery(server_id, [props.user_id]);

	const tooltip_type = props.tooltip_type ?? "Title";

	const member = members_query?.members?.find(
		(val) => val.id === props.user_id
	);

	const has_valid_discriminator =
		member?.discriminator && member.discriminator !== "0";

	const tooltip_text = `${member ? member.name : props.user_id}${
		has_valid_discriminator ? `#${member.discriminator}` : ""
	} (${props.user_id})`;

	const element = (
		<span
			className="flex items-center gap-2 overflow-hidden whitespace-nowrap"
			title={tooltip_type === "Title" ? tooltip_text : undefined}
		>
			{props.include_avatar && (
				<figure className="image is-24x24 flex-shrink-0">
					<img
						className="is-rounded"
						src={
							member?.avatar_url
								? `https://cdn.discordapp.com/${member.avatar_url}`
								: DashboardUtils.GetPlaceholderAvatarURL(
										props.user_id,
										32
								  )
						}
						width={24}
						height={24}
					/>
				</figure>
			)}
			<span className="min-w-0 max-w-full overflow-hidden overflow-ellipsis">
				{member ? (
					<>
						{member.name}
						{has_valid_discriminator && (
							// Add slight right padding so italic isnt cut off
							<span className="pr-[2px] italic">
								#{member.discriminator}
							</span>
						)}
					</>
				) : (
					props.user_id
				)}
			</span>
		</span>
	);

	if (tooltip_type === "SeshTooltip") {
		return (
			<WithTooltip style="Info" tooltip={tooltip_text}>
				{element}
			</WithTooltip>
		);
	} else {
		return element;
	}
}
